<div
  class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-space-between"
>
  <h5 class="mb-0">{{ breadcrumbs.at(-1)?.title }}</h5>

  <ol class="breadcrumb mb-0 ps-0">
    @for (breadcrumb of breadcrumbs; track breadcrumb; ) {
    <li class="breadcrumb-item" [ngClass]="{ 'fw-semibold': $last }">
      @if (!$last && breadcrumb.url) { @if($first) {
      <a [routerLink]="'dashboard'">
        <i class="ri-home-8-line"></i>{{ breadcrumb.label }}
      </a>
      } @else {
      <a [routerLink]="breadcrumb.url">
        {{ breadcrumb.label }}
      </a>
      } } @if ($last) {
      {{ breadcrumb?.label }}
      }
    </li>
    }
  </ol>
</div>
